import React from 'react'
import { Platform, StyleSheet } from 'react-native'
import { KeyboardAvoidingView, KeyboardAvoidingViewProps } from 'react-native-keyboard-controller'
import p from 'x/config/platform-specific'

const XKeyboardAvoidingView: React.FC<KeyboardAvoidingViewProps> = ({
  behavior = Platform.OS === 'ios' ? 'padding' : 'height',
  // keyboardVerticalOffset = Platform.OS === 'ios' ? 64 : 0,
  // keyboardVerticalOffset = p.op.isAndroid() ? 30 : undefined,
  keyboardVerticalOffset = p.op.isAndroid() ? 30 : 24,
  style,
  children,
  ...rest
}) => {
  return (
    <KeyboardAvoidingView behavior={behavior} keyboardVerticalOffset={keyboardVerticalOffset}  style={[styles.container, style]} {...rest}>
      {children}
    </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

export default XKeyboardAvoidingView
